<template>
  <div id="app">
    <transition name="show-from-left">
          <popover name="helpbattery" :width="240">
              <Help :titleChart="titleChart">
              <div slot="content">
                ...
              </div>
            </Help>
          </popover>
      </transition>

      <div class="title-charts title-bt-help title-mobile"> {{ $t("239") }}
        <!--<button class="bt-help" v-popover:helpbattery.right><i class="icon-help ti-help-alt"></i></button>-->
      </div>

    <highcharts :options="chartOptions" ref='chart'></highcharts>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Vue from 'vue'
import axios from 'axios';
import mixin from '../../../../utils/mixin'

import Popover  from 'vue-js-popover'
Vue.use(Popover)
import Help from 'src/components/Dashboard/Views/components/Help'

export default {
  name: 'charts',
  components: {
    Help
  },
  data () {
    return {
      titleChart: this.$t("239"),
      tableData: [],
      chartOptions: {
        colors: ['#8b3d88', '#90ed7d', '#e4d354', '#f45b5b', '#6b91c9', '#3e9b80', '#3257a8', '#dd6b7f', '#0984e3', '#ffeaa7', '#e84393', '#55efc4', '#636e72', '#ff7675', '#f1c40f', '#34495e'],
        chart: {
          type: 'column',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063'
        },
        title: {
            text: '',
            style: {
                color: '#E0E0E3',
                textTransform: 'uppercase',
                fontSize: '14px'
            }
        },
        subtitle: {
            style: {
                color: '#E0E0E3',
                textTransform: 'uppercase'
            }
        },
        xAxis: {
            categories: [],
            crosshair: true,
            gridLineColor: '#707073',
            labels: {
                style: {
                    color: '#E0E0E3'
                }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            title: {
                style: {
                    color: '#A0A0A3'
                },
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: '# Sensors',
                style: {
                    color: '#A0A0A3'
                }
            },
            gridLineColor: '#707073',
            labels: {
                style: {
                    color: '#E0E0E3'
                }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            tickWidth: 1,
        },
        tooltip: {
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            style: {
                color: '#F0F0F0'
            },
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name} </td>' +
                '<td style="padding:0"><b>{point.y} </b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true,
                    color: '#F0F0F3',
                    style: {
                        fontSize: '13px'
                    }
                },
                marker: {
                    lineColor: '#333'
                },
                events:{
                  click: this.loadGrid
                },
                cursor: 'pointer',
            },
            boxplot: {
                fillColor: '#505053'
            },
            candlestick: {
                lineColor: 'white'
            },
            errorbar: {
                color: 'white'
            },
            column: {
                pointPadding: 0.1,
                borderWidth: 0
            }
        },
        legend: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            itemStyle: {
                color: '#E0E0E3'
            },
            itemHoverStyle: {
                color: '#FFF'
            },
            itemHiddenStyle: {
                color: '#606063'
            },
            title: {
                style: {
                    color: '#C0C0C0',
                    fontSize: '14px'
                },
            },
            enabled: false
        },
        labels: {
            style: {
                color: '#707073'
            }
        },
        drilldown: {
            activeAxisLabelStyle: {
                color: '#F0F0F3'
            },
            activeDataLabelStyle: {
                color: '#F0F0F3'
            }
        },
        navigation: {
            buttonOptions: {
                symbolStroke: '#DDDDDD',
                theme: {
                    fill: '#505053'
                }
            }
        },
        // scroll charts
        rangeSelector: {
            buttonTheme: {
                fill: '#505053',
                stroke: '#000000',
                style: {
                    color: '#CCC'
                },
                states: {
                    hover: {
                        fill: '#707073',
                        stroke: '#000000',
                        style: {
                            color: 'white'
                        }
                    },
                    select: {
                        fill: '#000003',
                        stroke: '#000000',
                        style: {
                            color: 'white'
                        }
                    }
                }
            },
            inputBoxBorderColor: '#505053',
            inputStyle: {
                backgroundColor: '#333',
                color: 'silver'
            },
            labelStyle: {
                color: 'silver'
            }
        },
        navigator: {
            handles: {
                backgroundColor: '#666',
                borderColor: '#AAA'
            },
            outlineColor: '#CCC',
            maskFill: 'rgba(255,255,255,0.1)',
            series: {
                color: '#7798BF',
                lineColor: '#A6C7ED'
            },
            xAxis: {
                gridLineColor: '#505053'
            }
        },
        scrollbar: {
            barBackgroundColor: '#808083',
            barBorderColor: '#808083',
            buttonArrowColor: '#CCC',
            buttonBackgroundColor: '#606063',
            buttonBorderColor: '#606063',
            rifleColor: '#FFF',
            trackBackgroundColor: '#404043',
            trackBorderColor: '#404043'
        },
        series: [{
            name: [],
            color: [],
            data: []
        }],
        exporting: { enabled: false },
        credits: {
          enabled: false
        },
        loading: {
            labelStyle: {
                color: 'black',
                textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff',
            },
            style: {
                backgroundColor: 'none',
                opacity: 1,
            }
        },

      },//fim chartOptions
    }
  },
  methods: {
    ...mapMutations(['changeGridOnline']),

    loadGrid(event){
      let status = event.point.status;
      let point_name = event.point.name
      let NAME_CHART = this.$t("364") + ' - ' + point_name.toUpperCase()
      const ENDPOINT = `v1/mysemeq-ambev/get-bateria-status-grid?corp=${this.filtersOn.corp}&region=${this.filtersOn.region}&planta=${this.filtersOn.planta}&status=${status}&area_f=${this.filtersOn.area_f}&sector_f=${this.filtersOn.sector_f}&machine=${this.filtersOn.machine}&subset=${this.filtersOn.subset}`

      let gridOnline = {
        title: event.point.name,
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
          "area": [this.$t("311")],
          "setor": [this.$t("312")],
          "conj": [this.$t("316"), 'conjunto'],
          "conj_tag": [this.$t("317")],
          "equip": [this.$t("313")],
          "equip_tag": [this.$t("314")],
          "ponto": [this.$t("340")],
          "serie": [this.$t("339")],
          "versao": [this.$t("336")],
          "data": [this.$t("334")],
          "bateria": [this.$t("335")],
          "sinal_nivel": [this.$t("337")],
          "node": [this.$t("338"), 'nodo'],
          "status": ['Status'],
          "id_planta": ['id_planta']
        },
        show: true,
        titleHelp: 'Grid - ' + this.$t("364"),
        txtHelp: this.$t("365") 
      }

      if (!this.filtersOn.planta) {
        gridOnline.columns = {"rows": [''], 'planta': [this.$t("310"), 'planta_f'], ...gridOnline.columns}
      }
      else{
        gridOnline.columns = {"rows": [''],  ...gridOnline.columns}
      }

      if (this.filtersOn.planta) {
        gridOnline.title += ' - ' + this.filtersOn.planta_name
        delete gridOnline.columns['planta']
      }

      this.changeGridOnline(gridOnline);

    },

    getData(){
      const API = process.env.ROOT_API;
      //const ENDPOINT = 'v1/get-bateria-status'
      const ENDPOINT = 'v1/mysemeq-ambev/get-bateria-status'
      let self = this;

      this.$refs.chart.chart.showLoading();

      axios({method: 'GET', url: API + ENDPOINT, params: this.filtersOn, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(resp => {
          self.tableData = resp.data.result;
          self.$refs.chart.chart.hideLoading();
      })
      .catch(err => {
          self.$refs.chart.chart.showLoading('Error');

          // from mixin
          self.ApiErrorHandler(self, error.response.data.status_code);
      })

    },
    setChartData () {
        var self = this
        var res = self.tableData
        self.chartOptions.xAxis.categories = []
        self.chartOptions.series[0].data = []
        self.chartOptions.series[0].color = []
        res.forEach(function (it) {
            if(it.status == 0){
                it.color = '#f45b5b'
            }
            if(it.status == 1){
                it.color = '#f5c869'
            }
            if(it.status == 2){
                it.color = '#e4d354'
            }
            if(it.status == 3){
                it.color = '#3257a8'
            }
            if(it.status == 4){
                it.color = '#90ed7d'
            }
            if(it.status == 5){
                it.color = '#6b91c9'
            }

            self.chartOptions.xAxis.categories.push(it.name)
            self.chartOptions.series[0].data.push(it)

        })
    }
  },
  computed: {
    ...mapGetters(['filtersOn']),
  },
  watch: {
    filtersOn: function(newValue){
      this.getData();
    },
    tableData: function(){
      this.setChartData();
    }
  }
}
</script>
<style>
/*tspan {
    fill: #fff;
    stroke: none!important;
    stroke-width: 1px;
    stroke-linejoin: round;
    color: #fff;
    font-weight: normal;
    font-size: 10px;
}*/
.highcharts-drilldown-data-label text{
  text-decoration:none !important;
}
div[data-popover="helpbattery"] {
  left: 71% !important;
  top: 0% !important;
}

@media screen and (max-width: 650px) {
  .title-mobile{
    padding-top: 10%!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ChartsOnline/ChartsSensorBattery.vue